import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class SecondNav extends Component {

    // constructor(props){
    //     super(props)
    // }

    render() {
        return (
            <div>
                <div fixed="top">
                    <div className="second-nav-border" >
                        <div className="row">
                            <div className="col-md-12 row">
                                {/* <table style={{width: "100%"}}>
                                    <tbody>
                                        <tr>
                                            <td className="pointer">
                                                Home
                                            </td>
                                            <td className="pointer" style={{width: "24%"}}>
                                                Introductory Text
                                            </td>
                                            <td className="pointer">
                                                Portfolio
                                            </td>
                                            <td>
                                                Listing service
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> */}
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/seller-edit-profile`,
                                    }}>
                                        ホーム
                                    </Link>
                                </div>
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/seller-edit-intro`,
                                    }}>
                                        自己紹介文
                                    </Link>
                                </div>
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/seller-edit-portfolio`,
                                    }}>
                                        ポートフォリオ
                                    </Link>
                                </div>
                                <div className="col-md-3" style={{ textAlign: "center" }}>
                                    <Link style={{ color: "#777272" }} to={{
                                        pathname: `/service-list`,
                                    }}>
                                        出品サービス
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { SecondNav };